import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button, Box } from "@material-ui/core";
import MessagesTimeline from "./MessagesTimeline";
import { fetchMessagesAPI } from "./messagesAPI";
import { useStyles } from './MessagesDashboardStyles';

const MessagesDashboard = () => {
  const classes = useStyles();
  const history = useHistory();
  const [messages, setMessages] = useState([]);

  // Fetch messages on component mount
  useEffect(() => {
    const loadMessages = async () => {
      try {
        const response = await fetchMessagesAPI();
        if (response.status && response.data && response.data.batches) {
          setMessages(response.data.batches);
        }
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    };

    loadMessages();
  }, []);

  // Flatten all messages from all batches and take only first 3 messages
  const allMessages = messages.flatMap(batch => 
    batch.messages.map(msg => ({ ...msg, batchNumber: batch.batchNumber }))
  );
  const top3Messages = allMessages.slice(0, 3);
  
  // Create a single batch structure with top 3 messages (all from same batch)
  const displayedBatches = top3Messages.length > 0 ? [{
    batchNumber: top3Messages[0].batchNumber,
    messages: top3Messages
  }] : [];

  return (
    <>
      <div className={classes.root}>
        <Box className={classes.messagesContainer}>
          <MessagesTimeline 
            batches={displayedBatches} 
            viewType="card"
          />
        </Box>

        {allMessages.length > 3 && (
          <Box className={classes.buttonContainer}>
            <Button
              className={classes.viewAllButton}
              variant="contained"
              onClick={() => {
                history.push(
                  `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/productdevelopment/all-batch-updates`
                );
              }}
            >
              View All Batch Updates
            </Button>
          </Box>
        )}
      </div>
    </>
  );
};

export default MessagesDashboard;

